"use client";

import {
  FacebookShareButton,
  FacebookIcon,
  RedditShareButton,
  RedditIcon,
  TwitterIcon,
  TwitterShareButton,
  LinkedinIcon,
  LinkedinShareButton,
} from "next-share";

export default function ShareBar({ url, quote }) {
  return (
    <div className="flex gap-2">
      <div className="transition-transform duration-300 ease-in-out hover:-tranzinc-y-1">
        <FacebookShareButton
          url={url}
          quote={`${quote} - Pano News`}
          hashtag={`${quote} - Pano News`}
        >
          <FacebookIcon size={32} round />
        </FacebookShareButton>
      </div>
      <div className="transition-transform duration-300 ease-in-out hover:-tranzinc-y-1">
        <TwitterShareButton
          url={url}
          title={`${quote} - Pano News`}
          hashtags={["panonews"]}
          via={"panonews"}
        >
          <TwitterIcon size={32} round />
        </TwitterShareButton>
      </div>
      <div className="transition-transform duration-300 ease-in-out hover:-tranzinc-y-1">
        <LinkedinShareButton url={url}>
          <LinkedinIcon size={32} round />
        </LinkedinShareButton>
      </div>
      <div className="transition-transform duration-300 ease-in-out hover:-tranzinc-y-1">
        <RedditShareButton url={url} title={`${quote} - Pano News`}>
          <RedditIcon size={32} round />
        </RedditShareButton>
      </div>
    </div>
  );
}
